import { http } from '@/lib/http';
import type { APIResponse, CartInfo } from '@/types';

export type WebBackParams = {
  items: {
    userPrintId: number;
    quantity: number;
    timestamp: number;
  }[];
};

export type PostWebBackResponse = APIResponse<{ cart: CartInfo }>;

export const postMergeCart = async (params: WebBackParams) => {
  return await http<PostWebBackResponse>('/user/v1/gf/cart/merge', {
    method: 'POST',
    body: JSON.stringify({
      items: params.items.map((item) => ({
        user_print_id: item.userPrintId,
        quantity: item.quantity,
        timestamp: item.timestamp,
      })),
    }),
  });
};
